// extracted by mini-css-extract-plugin
export default {"PatientInfoPop":"PatientInfoPop_PatientInfoPop__f5T-Q","header":"PatientInfoPop_header__HJAUJ"};